<template>
	<div>
		<div v-if="errorMessage" class="notification is-danger is-light">
			{{ errorMessage }}
		</div>
		<form @submit.prevent="submit">
			<div class="content"><p>Please enter your new password.</p></div>
			<required-field
				:error="$v.password.$error"
				:required="$v.password.required"
				label="Password"
			>
				<input
					v-model.trim="$v.password.$model"
					class="input"
					type="password"
					:class="{ 'is-danger': $v.password.$error }"
				/>
				<p v-if="!$v.password.minLength" class="help is-danger">
					Password must have at least {{ $v.password.$params.minLength.min }}
				</p>
			</required-field>
			<div class="buttons mt-6">
				<button
					class="button is-primary is-fullwidth"
					:class="[{ 'is-loading': fetching }]"
					:disabled="!isValid"
				>
					Save
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import formMixin from "./formMixins";
import { required, minLength } from "vuelidate/lib/validators";

export default {
	name: "FormResetPassword",
	mixins: [formMixin],
	validations: {
		password: { required, minLength: minLength(8) }
	},
	data() {
		return {
			password: ""
		};
	},
	computed: {},
	methods: {
		async submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$emit("submit", { password: this.password });
			}
		}
	}
};
</script>

<style lang="scss" scoped>
form {
	margin-bottom: 1.5rem;
}
</style>
